<script>
  import Navbar from "../components/Navbar.svelte";
  import Sidebar from "../components/Sidebar.svelte";
  import Footer from "../components/Footer.svelte";
  import Par from "../components/Par.svelte";
</script>
<div class="max-w-full">
  <Navbar />
  <div class="grid grid-cols-3">
    <Sidebar>
    </Sidebar>
    <div class="grid col-span-3 md:col-span-2 px-8">
      <Par />
    </div>
  </div>
  <Footer />
</div>
